import * as dayjs from 'dayjs';

export const DATE_MODIFIERS = {
  toEndDate: (date: Date) => dayjs(date).endOf('day').toISOString()
};
